import type {
  PricingType,
  PricingTypeApi,
  PricingTypeFilters,
  PricingTypeFiltersUpdateApi,
  PricingTypes,
  PricingTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizePricingType = (pricingType: PricingTypeApi): PricingType => ({
  ...pricingType,
  id: pricingType.codeId ?? String(pricingType.id),
  label: pricingType.codeDesc,
});

export const normalizePricingTypes = (response: PricingTypesApi): PricingTypes => {
  const list = (response.items ?? []).sort((a, b) => a.codeDesc.localeCompare(b.codeDesc)).map(normalizePricingType);
  return {
    list,
    map: list.reduce(
      (acc, pricingType) => {
        acc[String(pricingType.id)] = pricingType;
        return acc;
      },
      {} as PricingTypes['map'],
    ),
  };
};

export const normalizePricingTypeFilters = (filters: Partial<PricingTypeFilters>): PricingTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
